/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request of add medical person in financial group
 * @export
 * @interface MedicalPersonFinancialGroupRequest
 */
export interface MedicalPersonFinancialGroupRequest {
    /**
     * the unique identifier of medical person
     * @type {string}
     * @memberof MedicalPersonFinancialGroupRequest
     */
    personId?: string;
    /**
     * the owner status of the medical person
     * @type {boolean}
     * @memberof MedicalPersonFinancialGroupRequest
     */
    isOwner?: boolean;
}

/**
 * Check if a given object implements the MedicalPersonFinancialGroupRequest interface.
 */
export function instanceOfMedicalPersonFinancialGroupRequest(value: object): value is MedicalPersonFinancialGroupRequest {
    return true;
}

export function MedicalPersonFinancialGroupRequestFromJSON(json: any): MedicalPersonFinancialGroupRequest {
    return MedicalPersonFinancialGroupRequestFromJSONTyped(json, false);
}

export function MedicalPersonFinancialGroupRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MedicalPersonFinancialGroupRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'personId': json['personId'] == null ? undefined : json['personId'],
        'isOwner': json['isOwner'] == null ? undefined : json['isOwner'],
    };
}

export function MedicalPersonFinancialGroupRequestToJSON(json: any): MedicalPersonFinancialGroupRequest {
    return MedicalPersonFinancialGroupRequestToJSONTyped(json, false);
}

export function MedicalPersonFinancialGroupRequestToJSONTyped(value?: MedicalPersonFinancialGroupRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'personId': value['personId'],
        'isOwner': value['isOwner'],
    };
}

